const initialState = {
    name_zh: '',
    name_en: '',
    url_original: '',
    url_colored: '',
    url_now: '',
    location: '',
    year: '',
    author: '',
    external_url: '',
    description_zh: '',
    description_en: '',
    s3_id: '',
    id: ''
}

export { initialState }